/**
 * Lady Kelly — Widget de tamanho (Shopify)
 * Uso: <script src="{{ 'widget.js' | asset_url }}" defer></script>
 * Abre ao clicar em "Descobrir meu tamanho" ou [data-lk-size-open]
 */
(function (global) {
  'use strict';

  var ID = 'lk-size-widget';
  var TRIGGER_LABEL = 'Descobrir meu tamanho';

  /* ─── Config ─── */
  var defaults = {
    // cor do botão (igual à referência da foto)
    accent: '#d35f54',
    accentDark: '#b85249',
    triggerText: TRIGGER_LABEL,
    calcDelay: 650
  };

  /* ─── Tabela Lady Kelly (cm) ─── */
  var SZ = {
    P: { b: [60, 87], w: [55, 68], h: [70, 94] },
    M: { b: [88, 93], w: [69, 75], h: [94, 102] },
    G: { b: [94, 100], w: [76, 82], h: [102, 110] },
    GG: { b: [101, 150], w: [83, 110], h: [110, 130] }
  };
  var SZ_ORDER = ['P', 'M', 'G', 'GG'];
  var FIT_ZONE = { lower: 0.28, upper: 0.78 };
  var BCOL = {
    perfect: '#2e7d55',
    adjusted: '#3d8f6a',
    loose: '#b5934a',
    tight: '#8e3a3a'
  };

  /* ─── CSS (escopo .lk-) ─── */
  var CSS =
    '@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");' +
    '#' + ID + ',#' + ID + ' *{box-sizing:border-box}' +
    '#' + ID + '{font-family:Inter,system-ui,-apple-system,sans-serif;-webkit-font-smoothing:antialiased}' +
    '#' + ID + ' .lk-overlay{position:fixed;inset:0;z-index:999999;background:rgba(0,0,0,.45);display:flex;align-items:center;justify-content:center;padding:12px;opacity:0;visibility:hidden;transition:opacity .28s ease,visibility .28s}' +
    '#' + ID + '.lk-open .lk-overlay{opacity:1;visibility:visible}' +
    // desktop mais proporcional (igual referência)
    '#' + ID + ' .lk-modal{background:#fff;border-radius:22px;width:100%;max-width:900px;max-height:min(92dvh,760px);overflow:hidden;overflow-y:auto;box-shadow:0 12px 50px rgba(0,0,0,.18);transform:translateY(12px) scale(.98);transition:transform .28s cubic-bezier(.22,1,.36,1)}' +
    '#' + ID + '.lk-open .lk-modal{transform:translateY(0) scale(1)}' +
    '#' + ID + ' .lk-scr{display:none}' +
    '#' + ID + ' .lk-scr.lk-on{display:block}' +
    '#' + ID + ' .lk-hdr{display:flex;align-items:center;justify-content:space-between;padding:20px 20px 0}' +
    '#' + ID + ' .lk-htitle{font-size:17px;font-weight:600;color:#111;letter-spacing:-.3px}' +
    '#' + ID + ' .lk-xbtn{width:32px;height:32px;border:none;background:#f2f2f2;border-radius:50%;cursor:pointer;font-size:14px;color:#666;display:flex;align-items:center;justify-content:center;touch-action:manipulation}' +
    '#' + ID + ' .lk-tab-row{padding:0 20px;margin-top:12px;border-bottom:1.5px solid #efefef}' +
    '#' + ID + ' .lk-tab-lbl{display:inline-block;font-size:13px;font-weight:600;color:#111;padding-bottom:9px;border-bottom:2px solid #111;margin-bottom:-1.5px}' +
    '#' + ID + ' .lk-mrows{padding:16px 20px 6px}' +
    '#' + ID + ' .lk-mrow{margin-bottom:18px}' +
    '#' + ID + ' .lk-mlbl-row{display:flex;justify-content:space-between;align-items:center;margin-bottom:10px}' +
    '#' + ID + ' .lk-mlbl{font-size:10px;font-weight:700;letter-spacing:1.5px;color:#aaa;text-transform:uppercase}' +
    // campo numérico premium (no lugar do slider)
    '#' + ID + ' .lk-measure{display:flex;align-items:center;gap:10px}' +
    '#' + ID + ' .lk-num{width:92px;height:44px;border:1.5px solid #e7e7e7;border-radius:14px;background:#fff;padding:0 12px;font-size:18px;font-weight:600;color:#111;outline:none;text-align:right}' +
    '#' + ID + ' .lk-num:focus{border-color:#111;box-shadow:0 0 0 3px rgba(17,17,17,.06)}' +
    '#' + ID + ' .lk-unit{font-size:12px;color:#bbb;margin-left:-6px;min-width:22px}' +
    '#' + ID + ' .lk-stepper{display:flex;gap:8px;align-items:center}' +
    '#' + ID + ' .lk-sbtn{width:44px;height:44px;border:1.5px solid #e5e5e5;background:#fff;border-radius:50%;cursor:pointer;font-size:20px;color:#444;display:flex;align-items:center;justify-content:center;flex-shrink:0;touch-action:manipulation}' +
    '#' + ID + ' .lk-sbtn:active{background:#f5f5f5;transform:scale(.94)}' +
    '#' + ID + ' .lk-div1{height:1px;background:#f5f5f5;margin:0 20px}' +
    '#' + ID + ' .lk-acts{display:flex;gap:8px;padding:12px 20px 0}' +
    '#' + ID + ' .lk-abtn{flex:1;padding:10px 4px;border:1.5px solid #ebebeb;background:#fff;border-radius:10px;font-size:9px;font-weight:700;color:#666;letter-spacing:.4px;cursor:pointer;text-transform:uppercase;touch-action:manipulation}' +
    '#' + ID + ' .lk-calcbtn{display:block;width:calc(100% - 40px);margin:12px 20px 18px;padding:16px;border:none;border-radius:14px;color:#fff;font-size:15px;font-weight:600;cursor:pointer;touch-action:manipulation}' +
    '#' + ID + ' .lk-calcbtn:disabled{opacity:.65}' +
    '#' + ID + ' .lk-ldots{display:none;gap:5px;align-items:center;justify-content:center}' +
    '#' + ID + ' .lk-ldots.lk-on{display:flex}' +
    '#' + ID + ' .lk-ldot{width:6px;height:6px;border-radius:50%;background:rgba(255,255,255,.8);animation:lk-bop 1s infinite}' +
    '#' + ID + ' .lk-ldot:nth-child(2){animation-delay:.15s}' +
    '#' + ID + ' .lk-ldot:nth-child(3){animation-delay:.3s}' +
    '@keyframes lk-bop{0%,80%,100%{transform:scale(.6)}40%{transform:scale(1)}}' +
    '#' + ID + ' .lk-s2wrap{display:flex;min-height:520px}' +
    '#' + ID + ' .lk-s2left{width:46%;background:#fff;position:relative;overflow:hidden;min-height:520px;border-right:1px solid #f1f1f1}' +
    '#' + ID + ' .lk-s2left-inner{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;padding:14px;background:#fff}' +
    // imagem proporcional (sem cortar)
    '#' + ID + ' .lk-prod-img{width:100%;height:100%;object-fit:contain;display:block}' +
    '#' + ID + ' .lk-prod-ph{width:100%;height:100%;background:#ece5dc;display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:600;color:#a89880;letter-spacing:1px;text-transform:uppercase}' +
    '#' + ID + ' .lk-guia-tag{position:absolute;bottom:12px;left:8px;right:8px;background:rgba(255,255,255,.93);border:none;border-radius:8px;padding:9px 6px;font-size:9px;font-weight:800;letter-spacing:.8px;color:#222;text-transform:uppercase;cursor:pointer}' +
    '#' + ID + ' .lk-s2right{flex:1;padding:16px 14px 14px;display:flex;flex-direction:column;position:relative;min-width:0}' +
    '#' + ID + ' .lk-bigsize{font-size:46px;font-weight:700;color:#111;line-height:1;letter-spacing:-2px}' +
    '#' + ID + ' .lk-reclbl{font-size:9px;font-weight:700;letter-spacing:1.8px;color:#999;text-transform:uppercase;margin-top:2px}' +
    '#' + ID + ' .lk-editlnk{font-size:12px;color:#111;text-decoration:underline;cursor:pointer;margin-top:4px;display:inline-block;background:none;border:none;padding:0;font:inherit}' +
    '#' + ID + ' .lk-s2-center{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%}' +
    '#' + ID + ' .lk-avzone{display:flex;align-items:center;justify-content:center;width:100%;min-height:180px}' +
    '#' + ID + ' .lk-av-composition{position:relative;width:100%;max-width:220px;height:clamp(175px,38vw,220px);margin:0 auto}' +
    '#' + ID + ' .lk-av-figure{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:108px;height:100%;display:flex;align-items:center;justify-content:center}' +
    '#' + ID + ' .lk-av-svg{width:100%;height:100%;display:block;overflow:visible}' +
    '#' + ID + ' .lk-av-tags{position:absolute;left:calc(50% + 54px);top:0;width:max-content;min-width:82px;height:100%;pointer-events:none}' +
    '#' + ID + ' .lk-ftag{position:absolute;left:0;transform:translateY(-50%);display:flex;align-items:center;gap:4px;border-radius:20px;padding:3px 8px 3px 5px;font-size:8.5px;font-weight:600;white-space:nowrap;max-width:118px;line-height:1.2;box-shadow:0 1px 4px rgba(0,0,0,.04)}' +
    '#' + ID + ' .lk-ftag.lk-perfect{background:#e8f5ec;color:#1a6e35}' +
    '#' + ID + ' .lk-ftag.lk-adjusted{background:#e6f3ee;color:#1a5c48}' +
    '#' + ID + ' .lk-ftag.lk-loose{background:#faf0d8;color:#7a5500}' +
    '#' + ID + ' .lk-ftag.lk-tight{background:#fce8e8;color:#8a1c1c}' +
    '#' + ID + ' .lk-fdot{width:7px;height:7px;border-radius:50%;flex-shrink:0}' +
    '#' + ID + ' .lk-ftag.lk-perfect .lk-fdot{background:#22a84a}' +
    '#' + ID + ' .lk-ftag.lk-adjusted .lk-fdot{background:#3d9a6e}' +
    '#' + ID + ' .lk-ftag.lk-loose .lk-fdot{background:#c47d00}' +
    '#' + ID + ' .lk-ftag.lk-tight .lk-fdot{background:#c0392b}' +
    '#' + ID + ' .lk-szrow{display:grid;grid-template-columns:repeat(4,1fr);gap:6px;margin:8px 0;width:100%;max-width:210px}' +
    '#' + ID + ' .lk-szbtn{padding:11px 2px;border:1.5px solid #ddd;background:#fff;border-radius:10px;font-size:13px;font-weight:600;color:#666;cursor:pointer;touch-action:manipulation}' +
    '#' + ID + ' .lk-szbtn.lk-sel{background:#111;color:#fff;border-color:#111}' +
    '#' + ID + ' .lk-szund{height:2px;background:#fff;border-radius:1px;width:50%;margin:2px auto 0;display:none}' +
    '#' + ID + ' .lk-szbtn.lk-sel .lk-szund{display:block}' +
    '#' + ID + ' .lk-refrow{display:flex;justify-content:center;margin-bottom:6px;width:100%;max-width:210px}' +
    '#' + ID + ' .lk-reficon{font-size:18px;color:#bbb;cursor:pointer;border:none;background:none;padding:4px}' +
    '#' + ID + ' .lk-contbtn{display:block;width:100%;padding:14px;border:none;border-radius:14px;color:#fff;font-size:14px;font-weight:600;cursor:pointer;margin-top:auto;touch-action:manipulation}' +
    '#' + ID + ' .lk-ghdr{display:flex;align-items:center;justify-content:space-between;padding:16px 18px 12px;border-bottom:1px solid #f0f0f0}' +
    '#' + ID + ' .lk-ghtit{font-size:11px;font-weight:700;letter-spacing:1.2px;color:#111;text-transform:uppercase}' +
    '#' + ID + ' .lk-gbk{width:32px;height:32px;border:none;background:#f2f2f2;border-radius:50%;cursor:pointer;font-size:15px}' +
    '#' + ID + ' .lk-gyours{background:#f9f9f9;padding:12px 18px}' +
    '#' + ID + ' .lk-gylab{font-size:9px;font-weight:700;letter-spacing:1px;color:#bbb;text-transform:uppercase;margin-bottom:8px}' +
    '#' + ID + ' .lk-gyvals{display:flex}' +
    '#' + ID + ' .lk-gyval{flex:1;text-align:center;font-size:18px;font-weight:500}' +
    '#' + ID + ' .lk-gyval em{font-size:11px;color:#bbb;font-style:normal}' +
    '#' + ID + ' .lk-gtab{width:100%;border-collapse:collapse;font-size:11px}' +
    '#' + ID + ' .lk-gtab th{font-size:9px;font-weight:700;color:#bbb;text-transform:uppercase;padding:8px 10px 6px;text-align:center}' +
    '#' + ID + ' .lk-gtab td{padding:8px 10px;text-align:center;color:#555;border-top:1px solid #f3f3f3}' +
    '#' + ID + ' .lk-gtab td:first-child{font-weight:700;color:#111;text-align:left}' +
    '#' + ID + ' .lk-gtab tr.lk-hl td{background:#111;color:#fff!important}' +
    '#' + ID + ' .lk-hlbadge{background:#111;color:#fff;border-radius:20px;padding:3px 10px;font-size:11px;font-weight:700}' +
    '#' + ID + ' .lk-sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}' +
    '@media(max-width:640px){' +
    '#' + ID + ' .lk-overlay{align-items:flex-end;padding:0}' +
    '#' + ID + ' .lk-modal{max-width:100%;border-radius:20px 20px 0 0;max-height:92dvh}' +
    '#' + ID + ' .lk-s2wrap{flex-direction:column;min-height:auto}' +
    // mobile: foto do produto maior e proporcional
    '#' + ID + ' .lk-s2left{width:100%;height:220px;flex-shrink:0;border-right:none;border-bottom:1px solid #f1f1f1}' +
    '#' + ID + ' .lk-bigsize{font-size:40px}' +
    '#' + ID + ' .lk-av-tags{left:calc(50% + 48px);min-width:76px}' +
    '#' + ID + ' .lk-ftag{font-size:8px;max-width:100px}' +
    '#' + ID + ' .lk-num{width:88px;height:42px;border-radius:13px;font-size:17px}' +
    '}';

  /* ─── HTML ─── */
  function buildHTML() {
    return (
      '<div class="lk-overlay" aria-hidden="true">' +
        '<div class="lk-modal" role="dialog" aria-modal="true" aria-labelledby="lk-dialog-title">' +
          '<h2 id="lk-dialog-title" class="lk-sr-only">Calculadora de tamanho Lady Kelly</h2>' +
          '<div class="lk-scr lk-on" data-screen="s1">' +
            '<div class="lk-hdr"><span class="lk-htitle">Adicione suas medidas</span><button type="button" class="lk-xbtn" data-lk-close aria-label="Fechar">✕</button></div>' +
            '<div class="lk-tab-row"><span class="lk-tab-lbl">Métrico</span></div>' +
            '<div class="lk-mrows">' +
              rowHTML('b', 'Busto', 60, 150, 90) +
              rowHTML('w', 'Cintura', 55, 130, 70) +
              rowHTML('h', 'Quadril', 70, 150, 95) +
            '</div>' +
            '<div class="lk-div1"></div>' +
            '<div class="lk-acts"><button type="button" class="lk-abtn" data-lk-guia>Ver guia de tamanhos</button></div>' +
            '<button type="button" class="lk-calcbtn" data-lk-calc><span data-lk-ctxt>Calcular meu tamanho</span><div class="lk-ldots" data-lk-dots><div class="lk-ldot"></div><div class="lk-ldot"></div><div class="lk-ldot"></div></div></button>' +
          '</div>' +
          '<div class="lk-scr" data-screen="s2">' +
            '<div class="lk-s2wrap">' +
              '<div class="lk-s2left"><div class="lk-s2left-inner" data-lk-prod-wrap></div><button type="button" class="lk-guia-tag" data-lk-guia>Ver guia de tamanhos</button></div>' +
              '<div class="lk-s2right">' +
                '<button type="button" class="lk-xbtn" style="position:absolute;top:12px;right:10px" data-lk-close aria-label="Fechar">✕</button>' +
                '<div class="lk-bigsize" data-lk-rsz>M</div>' +
                '<div class="lk-reclbl">Tamanho recomendado</div>' +
                '<button type="button" class="lk-editlnk" data-lk-s1>Editar medidas</button>' +
                '<div class="lk-s2-center">' +
                  '<div class="lk-avzone"><div class="lk-av-composition" data-lk-av-comp>' +
                    '<div class="lk-av-figure">' + avatarSVG() + '</div>' +
                    '<div class="lk-av-tags" data-lk-av-tags>' +
                      tagHTML('btag', 'btxt') + tagHTML('wtag', 'wtxt') + tagHTML('htag', 'htxt') +
                    '</div>' +
                  '</div></div>' +
                  '<div class="lk-szrow">' +
                    szBtn('P') + szBtn('M') + szBtn('G') + szBtn('GG') +
                  '</div>' +
                  '<div class="lk-refrow"><button type="button" class="lk-reficon" data-lk-s1 aria-label="Recalcular">↺</button></div>' +
                '</div>' +
                '<button type="button" class="lk-contbtn" data-lk-close>Continuar comprando</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="lk-scr" data-screen="s3">' +
            '<div class="lk-ghdr"><button type="button" class="lk-gbk" data-lk-guia-back>←</button><span class="lk-ghtit">Guia de tamanhos</span><button type="button" class="lk-xbtn" data-lk-guia-close>✕</button></div>' +
            '<div class="lk-gyours"><div class="lk-gylab">Suas medidas</div><div class="lk-gyvals">' +
              '<div class="lk-gyval"><span data-lk-gb>90</span><em>cm</em></div>' +
              '<div class="lk-gyval"><span data-lk-gw>70</span><em>cm</em></div>' +
              '<div class="lk-gyval"><span data-lk-gh>95</span><em>cm</em></div>' +
            '</div></div>' +
            '<div style="padding:0 4px 16px"><table class="lk-gtab"><thead><tr><th>Tamanho</th><th>Busto</th><th>Cintura</th><th>Quadril</th></tr></thead><tbody data-lk-gtbody></tbody></table></div>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function rowHTML(field, label, min, max, val) {
    return (
      '<div class="lk-mrow">' +
        '<div class="lk-mlbl-row"><span class="lk-mlbl">' + label + '</span></div>' +
        '<div class="lk-measure">' +
          '<div class="lk-stepper">' +
            '<button type="button" class="lk-sbtn" data-lk-adj="' + field + '" data-delta="-1" aria-label="Diminuir">−</button>' +
            '<input class="lk-num" type="number" inputmode="numeric" pattern="[0-9]*" data-lk-r="' + field + '" min="' + min + '" max="' + max + '" step="1" value="' + val + '">' +
            '<span class="lk-unit">cm</span>' +
            '<button type="button" class="lk-sbtn" data-lk-adj="' + field + '" data-delta="1" aria-label="Aumentar">+</button>' +
          '</div>' +
        '</div></div>'
    );
  }

  function tagHTML(tagId, txtId) {
    return '<div class="lk-ftag lk-perfect" data-lk-tag="' + tagId + '"><span class="lk-fdot"></span><span data-lk-txt="' + txtId + '">caimento perfeito</span></div>';
  }

  function szBtn(v) {
    return '<button type="button" class="lk-szbtn" data-lk-pick="' + v + '">' + v + '<div class="lk-szund"></div></button>';
  }

  function avatarSVG() {
    return (
      '<svg class="lk-av-svg" viewBox="0 0 100 220" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<defs>' +
          '<linearGradient id="lk-skinGrad" x1="30%" y1="0%" x2="70%" y2="100%"><stop offset="0%" stop-color="#faf8f6"/><stop offset="55%" stop-color="#f0ece8"/><stop offset="100%" stop-color="#e4dfd9"/></linearGradient>' +
          '<linearGradient id="lk-floorGrad" x1="50%" y1="0%" x2="50%" y2="100%"><stop offset="0%" stop-color="#ddd6ce" stop-opacity=".4"/><stop offset="100%" stop-color="#ddd6ce" stop-opacity="0"/></linearGradient>' +
          '<filter id="lk-bodySoft" x="-18%" y="-8%" width="136%" height="116%"><feDropShadow dx="0" dy="2.5" stdDeviation="2.8" flood-color="#c5bdb4" flood-opacity=".28"/></filter>' +
        '</defs>' +
        '<ellipse data-lk-floor fill="url(#lk-floorGrad)" cx="50" cy="216" rx="22" ry="3.5" opacity=".55"/>' +
        '<g filter="url(#lk-bodySoft)">' +
          '<ellipse data-lk-head fill="url(#lk-skinGrad)" stroke="#dbd4cc" stroke-width=".45"/>' +
          '<path data-lk-neck fill="url(#lk-skinGrad)" stroke="#dbd4cc" stroke-width=".35"/>' +
          '<path data-lk-arm-l fill="url(#lk-skinGrad)" stroke="#dbd4cc" stroke-width=".32" opacity=".94"/>' +
          '<path data-lk-arm-r fill="url(#lk-skinGrad)" stroke="#dbd4cc" stroke-width=".32" opacity=".94"/>' +
          '<path data-lk-torso fill="url(#lk-skinGrad)" stroke="#dbd4cc" stroke-width=".42"/>' +
          '<path data-lk-leg-l fill="url(#lk-skinGrad)" stroke="#dbd4cc" stroke-width=".35"/>' +
          '<path data-lk-leg-r fill="url(#lk-skinGrad)" stroke="#dbd4cc" stroke-width=".35"/>' +
        '</g>' +
        '<g data-lk-bands>' +
          '<line data-lk-band="bl-glow" stroke-width="5" stroke-linecap="round" opacity="0" class="lk-band-glow"/>' +
          '<line data-lk-band="wl-glow" stroke-width="5" stroke-linecap="round" opacity="0" class="lk-band-glow"/>' +
          '<line data-lk-band="hl-glow" stroke-width="5" stroke-linecap="round" opacity="0" class="lk-band-glow"/>' +
          '<line data-lk-band="bl" stroke-width="2.2" stroke-linecap="round"/>' +
          '<line data-lk-band="wl" stroke-width="2.2" stroke-linecap="round"/>' +
          '<line data-lk-band="hl" stroke-width="2.2" stroke-linecap="round"/>' +
        '</g></svg>'
    );
  }

  /* ─── Size logic ─── */
  function szIndex(sz) { return SZ_ORDER.indexOf(sz); }

  function maxSize() {
    var a = arguments;
    var best = a[0];
    for (var i = 1; i < a.length; i++) if (szIndex(a[i]) > szIndex(best)) best = a[i];
    return best;
  }

  function requiredSizeForMeasure(value, dim) {
    var i, sz, min, max;
    for (i = 0; i < SZ_ORDER.length; i++) {
      sz = SZ_ORDER[i];
      min = SZ[sz][dim][0];
      max = SZ[sz][dim][1];
      if (value < min) return sz;
      if (value <= max) {
        if (value === max && i < SZ_ORDER.length - 1) return SZ_ORDER[i + 1];
        return sz;
      }
    }
    return 'GG';
  }

  function recommendSize(bust, waist, hip) {
    return maxSize(
      requiredSizeForMeasure(bust, 'b'),
      requiredSizeForMeasure(waist, 'w'),
      requiredSizeForMeasure(hip, 'h')
    );
  }

  function fitZone(v, range) {
    var min = range[0], max = range[1], span, pos;
    if (v > max) return 'tight';
    if (v < min) return 'loose';
    span = max - min || 1;
    pos = (v - min) / span;
    if (pos <= FIT_ZONE.lower) return 'loose';
    if (pos >= FIT_ZONE.upper) return 'adjusted';
    return 'perfect';
  }

  function fitLabel(f) {
    return { perfect: 'caimento perfeito', adjusted: 'caimento ajustado', loose: 'caimento soltinho', tight: 'muito justo' }[f] || '';
  }

  /* ─── Avatar geometry ─── */
  var AV = { cx: 50, vh: 220, ease: 0.17, cur: { bN: 0.375, wN: 0.2, hN: 0.3125 }, tgt: null, raf: null };

  function norm(v, min, max) {
    return Math.max(0, Math.min(1, (v - min) / (max - min)));
  }

  function computeGeom(s) {
    var cx = AV.cx, bW = 13.5 + s.bN * 15.5, wW = 7.5 + s.wN * 13, hW = 15 + s.hN * 16.5, sW = 11 + s.bN * 7;
    var y = { neckTop: 35, neckBot: 43, shoulder: 49, bust: 74, waist: 105, hip: 135, groin: 156, knee: 186, floor: 214 };
    var rx = function (hw) { return { l: cx - hw, r: cx + hw }; };
    return { cx: cx, bW: bW, wW: wW, hW: hW, sW: sW, y: y, sh: rx(sW), bust: rx(bW), waist: rx(wW), hip: rx(hW), groin: rx(hW * 0.68), knee: rx(hW * 0.48), ankle: rx(hW * 0.36) };
  }

  function buildPaths(geo) {
    var cx = geo.cx, y = geo.y, sh = geo.sh, bust = geo.bust, waist = geo.waist, hip = geo.hip, groin = geo.groin, knee = geo.knee, ankle = geo.ankle, hW = geo.hW;
    return {
      torso: 'M ' + sh.l + ' ' + y.shoulder + ' C ' + sh.l + ' ' + (y.shoulder + 5) + ', ' + bust.l + ' ' + (y.bust - 12) + ', ' + bust.l + ' ' + y.bust + ' C ' + bust.l + ' ' + (y.bust + 9) + ', ' + waist.l + ' ' + (y.waist - 7) + ', ' + waist.l + ' ' + y.waist + ' C ' + waist.l + ' ' + (y.waist + 9) + ', ' + hip.l + ' ' + (y.hip - 7) + ', ' + hip.l + ' ' + y.hip + ' L ' + groin.l + ' ' + y.groin + ' L ' + groin.r + ' ' + y.groin + ' L ' + hip.r + ' ' + y.hip + ' C ' + hip.r + ' ' + (y.hip - 7) + ', ' + waist.r + ' ' + (y.waist + 9) + ', ' + waist.r + ' ' + y.waist + ' C ' + waist.r + ' ' + (y.waist - 7) + ', ' + bust.r + ' ' + (y.bust + 9) + ', ' + bust.r + ' ' + y.bust + ' C ' + bust.r + ' ' + (y.bust - 12) + ', ' + sh.r + ' ' + (y.shoulder + 5) + ', ' + sh.r + ' ' + y.shoulder + ' Z',
      neck: 'M ' + (cx - 6) + ' ' + y.neckTop + ' Q ' + cx + ' ' + (y.neckTop - 3) + ' ' + (cx + 6) + ' ' + y.neckTop + ' L ' + (cx + 5) + ' ' + y.neckBot + ' Q ' + cx + ' ' + (y.neckBot + 2.5) + ' ' + (cx - 5) + ' ' + y.neckBot + ' Z',
      legL: 'M ' + groin.l + ' ' + y.groin + ' L ' + (knee.l + 2) + ' ' + y.knee + ' L ' + (ankle.l + 2) + ' ' + y.floor + ' L ' + (cx - hW * 0.28) + ' ' + y.floor + ' L ' + (cx - hW * 0.48) + ' ' + y.knee + ' L ' + (cx - hW * 0.66) + ' ' + y.groin + ' Z',
      legR: 'M ' + groin.r + ' ' + y.groin + ' L ' + (knee.r - 2) + ' ' + y.knee + ' L ' + (ankle.r - 2) + ' ' + y.floor + ' L ' + (cx + hW * 0.28) + ' ' + y.floor + ' L ' + (cx + hW * 0.48) + ' ' + y.knee + ' L ' + (cx + hW * 0.66) + ' ' + y.groin + ' Z',
      armL: 'M ' + sh.l + ' ' + y.shoulder + ' C ' + (sh.l - 7) + ' ' + (y.shoulder + 12) + ', ' + (sh.l - 9) + ' ' + (y.bust + 2) + ', ' + (sh.l - 7) + ' ' + (y.bust + 18) + ' C ' + (sh.l - 5) + ' ' + (y.bust + 32) + ', ' + (sh.l - 2) + ' ' + (y.waist + 4) + ', ' + (sh.l + 3) + ' ' + (y.waist + 12) + ' L ' + (sh.l + 7) + ' ' + (y.waist + 10) + ' C ' + (sh.l + 4) + ' ' + y.waist + ', ' + (sh.l + 1) + ' ' + (y.bust + 26) + ', ' + sh.l + ' ' + (y.bust + 10) + ' C ' + (sh.l + 1) + ' ' + (y.shoulder + 6) + ', ' + (sh.l + 2) + ' ' + (y.shoulder + 2) + ', ' + sh.l + ' ' + y.shoulder + ' Z',
      armR: 'M ' + sh.r + ' ' + y.shoulder + ' C ' + (sh.r + 7) + ' ' + (y.shoulder + 12) + ', ' + (sh.r + 9) + ' ' + (y.bust + 2) + ', ' + (sh.r + 7) + ' ' + (y.bust + 18) + ' C ' + (sh.r + 5) + ' ' + (y.bust + 32) + ', ' + (sh.r + 2) + ' ' + (y.waist + 4) + ', ' + (sh.r - 3) + ' ' + (y.waist + 12) + ' L ' + (sh.r - 7) + ' ' + (y.waist + 10) + ' C ' + (sh.r - 4) + ' ' + y.waist + ', ' + (sh.r - 1) + ' ' + (y.bust + 26) + ', ' + sh.r + ' ' + (y.bust + 10) + ' C ' + (sh.r - 1) + ' ' + (y.shoulder + 6) + ', ' + (sh.r - 2) + ' ' + (y.shoulder + 2) + ', ' + sh.r + ' ' + y.shoulder + ' Z',
      head: { cx: cx, cy: 21, rx: 10.5, ry: 12.5 }
    };
  }

  /* ─── Widget ─── */
  function Widget(cfg) {
    this.cfg = Object.assign({}, defaults, cfg || global.LadyKellySizeConfig || {});
    this.root = null;
    this.recSz = '';
    this.prevScr = 's1';
    this.open = false;
    this._scrollY = 0;
  }

  Widget.prototype.mount = function () {
    if (document.getElementById(ID)) return this;
    this.injectStyles();
    this.root = document.createElement('div');
    this.root.id = ID;
    this.root.innerHTML = buildHTML();
    document.body.appendChild(this.root);
    this.applyTheme();
    this.cacheEls();
    this.bindEvents();
    this.setProductImage();
    this.initAvatar();
    return this;
  };

  Widget.prototype.injectStyles = function () {
    if (document.getElementById(ID + '-css')) return;
    var el = document.createElement('style');
    el.id = ID + '-css';
    el.textContent = CSS;
    document.head.appendChild(el);
  };

  Widget.prototype.applyTheme = function () {
    var c = this.cfg.accent, d = this.cfg.accentDark;
    this.root.querySelectorAll('.lk-calcbtn,.lk-contbtn').forEach(function (btn) {
      btn.style.background = c;
    });
    var style = document.getElementById(ID + '-theme');
    if (!style) {
      style = document.createElement('style');
      style.id = ID + '-theme';
      document.head.appendChild(style);
    }
    style.textContent =
      '#' + ID + ' .lk-calcbtn:active,#' + ID + ' .lk-contbtn:active{background:' + d + '!important}';
  };

  Widget.prototype.cacheEls = function () {
    var r = this.root;
    this.els = {
      overlay: r.querySelector('.lk-overlay'),
      modal: r.querySelector('.lk-modal'),
      screens: r.querySelectorAll('.lk-scr'),
      sliders: { b: r.querySelector('[data-lk-r="b"]'), w: r.querySelector('[data-lk-r="w"]'), h: r.querySelector('[data-lk-r="h"]') },
      vals: { b: r.querySelector('[data-lk-v="b"]'), w: r.querySelector('[data-lk-v="w"]'), h: r.querySelector('[data-lk-v="h"]') },
      rsz: r.querySelector('[data-lk-rsz]'),
      calcBtn: r.querySelector('[data-lk-calc]'),
      calcTxt: r.querySelector('[data-lk-ctxt]'),
      dots: r.querySelector('[data-lk-dots]'),
      szBtns: r.querySelectorAll('[data-lk-pick]'),
      prodWrap: r.querySelector('[data-lk-prod-wrap]'),
      avComp: r.querySelector('[data-lk-av-comp]'),
      avTags: r.querySelector('[data-lk-av-tags]'),
      svg: {
        head: r.querySelector('[data-lk-head]'),
        neck: r.querySelector('[data-lk-neck]'),
        torso: r.querySelector('[data-lk-torso]'),
        legL: r.querySelector('[data-lk-leg-l]'),
        legR: r.querySelector('[data-lk-leg-r]'),
        armL: r.querySelector('[data-lk-arm-l]'),
        armR: r.querySelector('[data-lk-arm-r]'),
        floor: r.querySelector('[data-lk-floor]')
      },
      bands: {},
      tags: { b: r.querySelector('[data-lk-tag="btag"]'), w: r.querySelector('[data-lk-tag="wtag"]'), h: r.querySelector('[data-lk-tag="htag"]') },
      txts: { b: r.querySelector('[data-lk-txt="btxt"]'), w: r.querySelector('[data-lk-txt="wtxt"]'), h: r.querySelector('[data-lk-txt="htxt"]') },
      gtbody: r.querySelector('[data-lk-gtbody]'),
      gb: r.querySelector('[data-lk-gb]'),
      gw: r.querySelector('[data-lk-gw]'),
      gh: r.querySelector('[data-lk-gh]')
    };
    var self = this;
    r.querySelectorAll('[data-lk-band]').forEach(function (ln) {
      self.els.bands[ln.getAttribute('data-lk-band')] = ln;
    });
  };

  Widget.prototype.bindEvents = function () {
    var self = this, r = this.root;

    r.addEventListener('click', function (e) {
      var t = e.target.closest('[data-lk-close],[data-lk-calc],[data-lk-adj],[data-lk-pick],[data-lk-s1],[data-lk-guia],[data-lk-guia-back],[data-lk-guia-close]');
      if (!t) {
        if (e.target === self.els.overlay) self.close();
        return;
      }
      if (t.hasAttribute('data-lk-close')) { e.preventDefault(); self.close(); return; }
      if (t.hasAttribute('data-lk-calc')) { self.calcular(); return; }
      if (t.hasAttribute('data-lk-s1')) { self.showScreen('s1'); return; }
      if (t.hasAttribute('data-lk-guia')) { self.openGuia(); return; }
      if (t.hasAttribute('data-lk-guia-back') || t.hasAttribute('data-lk-guia-close')) { self.closeGuia(); return; }
      if (t.hasAttribute('data-lk-pick')) { self.pickSz(t.getAttribute('data-lk-pick')); return; }
      if (t.hasAttribute('data-lk-adj')) {
        self.adj(t.getAttribute('data-lk-adj'), +t.getAttribute('data-delta'));
      }
    });

    r.addEventListener('input', function (e) {
      if (e.target.matches('[data-lk-r]')) {
        var f = e.target.getAttribute('data-lk-r');
        self.upd(f, e.target.value);
        self.renderAvatar();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.open) self.close();
    });

    window.addEventListener('resize', function () {
      if (self.root) self.applyGeomToDOM(computeGeom(AV.cur));
    });
  };

  Widget.prototype.getMeasures = function () {
    return { b: +this.els.sliders.b.value, w: +this.els.sliders.w.value, h: +this.els.sliders.h.value };
  };

  Widget.prototype.readMeasuresNorm = function () {
    var m = this.getMeasures();
    return {
      bN: norm(m.b, 60, 150),
      wN: norm(m.w, 55, 110),
      hN: norm(m.h, 70, 130)
    };
  };

  Widget.prototype.upd = function (f, v) {
    var el = this.els.sliders[f];
    var n = Math.round(+v);
    if (!el) return;
    var min = +el.min, max = +el.max;
    if (!Number.isFinite(n)) n = min;
    n = Math.min(Math.max(n, min), max);
    el.value = n;
  };

  Widget.prototype.adj = function (f, d) {
    var el = this.els.sliders[f];
    el.value = Math.min(Math.max(+el.value + d, +el.min), +el.max);
    this.upd(f, el.value);
    this.renderAvatar();
  };

  Widget.prototype.showScreen = function (id) {
    var self = this;
    this.els.screens.forEach(function (s) {
      s.classList.toggle('lk-on', s.getAttribute('data-screen') === id);
    });
    this.prevScr = id;
  };

  Widget.prototype.openModal = function () {
    this.open = true;
    this.root.classList.add('lk-open');
    this.els.overlay.setAttribute('aria-hidden', 'false');
    this._scrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + this._scrollY + 'px';
    document.body.style.width = '100%';
    this.setProductImage();
    this.renderAvatar();
  };

  Widget.prototype.close = function () {
    this.open = false;
    this.root.classList.remove('lk-open');
    this.els.overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, this._scrollY || 0);
  };

  Widget.prototype.setProductImage = function () {
    var url = getProductImageUrl(), wrap = this.els.prodWrap;
    wrap.innerHTML = '';
    if (url) {
      var img = document.createElement('img');
      img.className = 'lk-prod-img';
      img.src = url;
      img.alt = getProductTitle();
      wrap.appendChild(img);
    } else {
      var ph = document.createElement('div');
      ph.className = 'lk-prod-ph';
      ph.textContent = 'Produto';
      wrap.appendChild(ph);
    }
  };

  Widget.prototype.initAvatar = function () {
    AV.tgt = this.readMeasuresNorm();
    AV.cur = { bN: AV.tgt.bN, wN: AV.tgt.wN, hN: AV.tgt.hN };
    this.applyGeomToDOM(computeGeom(AV.cur));
  };

  Widget.prototype.setLine = function (key, x1, y1, x2, y2) {
    var el = this.els.bands[key];
    if (!el) return;
    el.setAttribute('x1', x1);
    el.setAttribute('y1', y1);
    el.setAttribute('x2', x2);
    el.setAttribute('y2', y2);
  };

  Widget.prototype.applyGeomToDOM = function (geo) {
    var p = buildPaths(geo), svg = this.els.svg;
    svg.head.setAttribute('cx', p.head.cx);
    svg.head.setAttribute('cy', p.head.cy);
    svg.head.setAttribute('rx', p.head.rx);
    svg.head.setAttribute('ry', p.head.ry);
    svg.neck.setAttribute('d', p.neck);
    svg.torso.setAttribute('d', p.torso);
    svg.legL.setAttribute('d', p.legL);
    svg.legR.setAttribute('d', p.legR);
    svg.armL.setAttribute('d', p.armL);
    svg.armR.setAttribute('d', p.armR);
    var pad = 1.5, self = this;
    [['bl', 'bl-glow', geo.bust, geo.y.bust], ['wl', 'wl-glow', geo.waist, geo.y.waist], ['hl', 'hl-glow', geo.hip, geo.y.hip]].forEach(function (b) {
      self.setLine(b[0], b[2].l + pad, b[3], b[2].r - pad, b[3]);
      self.setLine(b[1], b[2].l, b[3], b[2].r, b[3]);
    });
    svg.floor.setAttribute('rx', 14 + geo.hW * 0.35);
    this.positionTags(geo);
  };

  Widget.prototype.positionTags = function (geo) {
    var comp = this.els.avComp, tags = this.els.avTags;
    if (!comp || !comp.offsetHeight) return;
    var h = comp.offsetHeight, ys = { b: geo.y.bust, w: geo.y.waist, h: geo.y.hip }, self = this;
    Object.keys(ys).forEach(function (k) {
      var el = self.els.tags[k];
      if (el) el.style.top = (ys[k] / AV.vh * h) + 'px';
    });
  };

  Widget.prototype.lerpState = function () {
    var self = this, d = AV.ease, moving = false;
    ['bN', 'wN', 'hN'].forEach(function (k) {
      var diff = AV.tgt[k] - AV.cur[k];
      if (Math.abs(diff) > 0.001) { AV.cur[k] += diff * d; moving = true; }
      else AV.cur[k] = AV.tgt[k];
    });
    this.applyGeomToDOM(computeGeom(AV.cur));
    if (moving) AV.raf = requestAnimationFrame(function () { self.lerpState(); });
    else {
      AV.raf = null;
      if (self.recSz) self.applyBandColors(self.recSz);
      else {
        var m = self.getMeasures();
        self.applyBandColors(recommendSize(m.b, m.w, m.h));
      }
    }
  };

  Widget.prototype.renderAvatar = function () {
    var self = this;
    AV.tgt = this.readMeasuresNorm();
    if (AV.raf) cancelAnimationFrame(AV.raf);
    AV.raf = requestAnimationFrame(function () { self.lerpState(); });
    if (this.recSz) this.applyBandColors(this.recSz);
  };

  Widget.prototype.applyBandColors = function (sz) {
    var m = this.getMeasures(), s = SZ[sz], self = this;
    var map = [['b', m.b, s.b, 'bl', 'bl-glow'], ['w', m.w, s.w, 'wl', 'wl-glow'], ['h', m.h, s.h, 'hl', 'hl-glow']];
    map.forEach(function (row) {
      var k = row[0], v = row[1], range = row[2], lid = row[3], gid = row[4];
      var f = fitZone(v, range), col = BCOL[f];
      var el = self.els.bands[lid], glow = self.els.bands[gid];
      if (el) {
        el.setAttribute('stroke', col);
        el.setAttribute('stroke-width', f === 'perfect' || f === 'adjusted' ? 2.5 : 2.1);
      }
      if (glow) {
        glow.setAttribute('stroke', col);
        glow.style.opacity = f === 'perfect' || f === 'adjusted' ? '0.35' : '0';
      }
      var tag = self.els.tags[k], txt = self.els.txts[k];
      if (tag) tag.className = 'lk-ftag lk-' + f;
      if (txt) txt.textContent = fitLabel(f);
    });
  };

  Widget.prototype.pickSz = function (sz) {
    var self = this;
    this.els.szBtns.forEach(function (btn) {
      btn.classList.toggle('lk-sel', btn.getAttribute('data-lk-pick') === sz);
    });
    this.els.rsz.textContent = sz;
    this.applyBandColors(sz);
  };

  Widget.prototype.calcular = function () {
    var self = this, m = this.getMeasures();
    this.els.calcBtn.disabled = true;
    this.els.calcTxt.style.display = 'none';
    this.els.dots.classList.add('lk-on');
    setTimeout(function () {
      var sz = recommendSize(m.b, m.w, m.h);
      self.recSz = sz;
      self.els.calcBtn.disabled = false;
      self.els.calcTxt.style.display = '';
      self.els.dots.classList.remove('lk-on');
      self.renderAvatar();
      self.pickSz(sz);
      self.showScreen('s2');
    }, self.cfg.calcDelay);
  };

  Widget.prototype.openGuia = function () {
    var m = this.getMeasures(), rec = this.recSz || recommendSize(m.b, m.w, m.h), self = this;
    this.els.gb.textContent = Math.round(m.b);
    this.els.gw.textContent = Math.round(m.w);
    this.els.gh.textContent = Math.round(m.h);
    this.els.gtbody.innerHTML = '';
    SZ_ORDER.forEach(function (sz) {
      var r = SZ[sz], tr = document.createElement('tr');
      if (sz === rec) tr.classList.add('lk-hl');
      var t1 = document.createElement('td');
      t1.innerHTML = sz === rec ? '<span class="lk-hlbadge">' + sz + '</span>' : sz;
      var t2 = document.createElement('td'); t2.textContent = r.b[0] + '–' + r.b[1];
      var t3 = document.createElement('td'); t3.textContent = r.w[0] + '–' + r.w[1];
      var t4 = document.createElement('td'); t4.textContent = r.h[0] + '–' + r.h[1];
      tr.append(t1, t2, t3, t4);
      self.els.gtbody.appendChild(tr);
    });
    this.guiaPrev = this.root.querySelector('.lk-scr.lk-on').getAttribute('data-screen');
    this.showScreen('s3');
  };

  Widget.prototype.closeGuia = function () {
    this.showScreen(this.guiaPrev || 's1');
  };

  /* ─── Shopify helpers ─── */
  function getProductImageUrl() {
    if (global.meta && global.meta.product && global.meta.product.featured_image) {
      return global.meta.product.featured_image;
    }
    if (global.Shopify && global.Shopify.current_product && global.Shopify.current_product.featured_image) {
      return global.Shopify.current_product.featured_image;
    }
    var img = document.querySelector(
      '.product__media img[src], .product-media img[src], [data-product-featured-image], .product-single__photo img, #ProductPhotoImg'
    );
    if (img) return img.currentSrc || img.src || '';
    var og = document.querySelector('meta[property="og:image"]');
    return og ? og.content : '';
  }

  function getProductTitle() {
    if (global.meta && global.meta.product && global.meta.product.title) return global.meta.product.title;
    var h = document.querySelector('.product__title, .product-title, h1.title');
    return h ? h.textContent.trim() : 'Produto';
  }

  function bindTriggers(widget) {
    var text = (widget.cfg.triggerText || TRIGGER_LABEL).trim().toLowerCase();

    document.addEventListener('click', function (e) {
      var explicit = e.target.closest('[data-lk-size-open]');
      if (explicit) {
        e.preventDefault();
        widget.openModal();
        return;
      }
      var node = e.target.closest('a,button,[role="button"]');
      if (!node || node.closest('#' + ID)) return;
      var label = (node.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (label.indexOf(text) !== -1) {
        e.preventDefault();
        widget.openModal();
      }
    }, true);
  }

  function boot() {
    var widget = new Widget();
    widget.mount();
    bindTriggers(widget);
    global.LadyKellySizeWidget = {
      open: function () { widget.openModal(); },
      close: function () { widget.close(); },
      recalculate: function () { widget.calcular(); },
      getRecommendedSize: function () {
        var m = widget.getMeasures();
        return recommendSize(m.b, m.w, m.h);
      },
      instance: widget
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(typeof window !== 'undefined' ? window : this);
